import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/HandSign/editor/handsigneditor.tsx",
    () => import("./handsigneditor"),
);
